module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_italy.af1297cd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_italy.png
// module id = 1254
// module chunks = 16